import { getEstabelecimentos } from '../services/api';

export function escapeHtml(value) {
  return String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

/** Monta data-URL a partir do base64 vindo da API. */
export function logoDataUrl(base64) {
  const raw = String(base64 || '').trim();
  if (!raw) return '';
  if (raw.startsWith('data:')) return raw;
  const mime = raw.startsWith('/9j') ? 'image/jpeg' : 'image/png';
  return `data:${mime};base64,${raw}`;
}

/**
 * Estabelecimento + logo do sistema (Configuração → Aparência dos PDVs).
 * Usado nos PDFs/impressões do Gestão.
 */
export async function loadReportCompany() {
  const companyResponse = await getEstabelecimentos();
  const raw = companyResponse.data;
  const company = Array.isArray(raw) ? raw[0] || {} : raw || {};
  return {
    ...company,
    logoSrc: logoDataUrl(
      company.logoSistemaBase64 || company.LogoSistemaBase64 || '',
    ),
  };
}

/** CSS compartilhado do cabeçalho com logo. */
export const REPORT_BRAND_CSS = `
  .report-brand { display: flex; align-items: center; gap: 12px; min-width: 0; }
  .report-logo { max-height: 52px; max-width: 140px; object-fit: contain; flex-shrink: 0; }
  .company { color: #0495f0; font-size: 16px; font-weight: 800; }
  .document { color: #5f6878; font-size: 11px; font-weight: 700; text-transform: uppercase; }
`;

/**
 * Bloco esquerdo do cabeçalho: logo + nome / razão / CNPJ + título.
 * @param {object} company
 * @param {{ title?: string, documentLabel?: string, extraHtml?: string, fallbackName?: string }} opts
 */
export function reportBrandHtml(company = {}, opts = {}) {
  const {
    title = '',
    documentLabel = 'ZenGestão',
    extraHtml = '',
    fallbackName = 'Estabelecimento',
  } = opts;
  const companyName =
    company.nomeFantasia || company.razaoSocial || fallbackName;
  const cnpj = company.cnpj || company.cNPJ || company.CNPJ || '';
  const logo = company.logoSrc
    ? `<img class="report-logo" src="${company.logoSrc}" alt="" />`
    : '';
  const razao =
    company.razaoSocial && company.razaoSocial !== companyName
      ? `<div>${escapeHtml(company.razaoSocial)}</div>`
      : '';
  const cnpjHtml = cnpj ? `<div>CNPJ: ${escapeHtml(cnpj)}</div>` : '';
  const titleHtml = title ? `<h1>${escapeHtml(title)}</h1>` : '';
  const docHtml = documentLabel
    ? `<div class="document">${escapeHtml(documentLabel)}</div>`
    : '';

  return `<div class="report-brand">
    ${logo}
    <div>
      <div class="company">${escapeHtml(companyName)}</div>
      ${razao}
      ${cnpjHtml}
      ${titleHtml}
      ${docHtml}
      ${extraHtml}
    </div>
  </div>`;
}
